import script from "./FlightBooker.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightBooker.vue?vue&type=script&setup=true&lang=js"

import "./FlightBooker.vue?vue&type=style&index=0&id=94734b14&lang=css"

const __exports__ = script;

export default __exports__